import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static values = { id: Number }

  connect() {
    window.addEventListener("popstate", (event) => {
      // If a state has been provided, we have a "simulated" page
      // and we update the current page.
      if (event.state) {
        // Simulate the loading of the previous page
        Turbo.visit(
          `/projects/${this.idValue}/edit`,
          { action: "replace" }
        );
      }
    }, { once: true });
  }
}
